var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNuvemshop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 48,
    viewBox: "0 0 64 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 48,
    rx: 6,
    fill: "#2C3357"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.2796 13H36.2555C33.3825 13 30.6537 14.1217 28.6221 16.1239C27.5883 15.6776 26.4463 15.4364 25.2802 15.4364C20.58 15.4364 16.7693 19.2961 16.7693 24C16.7693 28.716 20.592 32.5636 25.3043 32.5636C26.4463 32.5636 27.5883 32.3224 28.6221 31.8761C30.5936 33.818 33.2983 35 36.2555 35C42.3142 35 47.2308 30.0669 47.2308 23.9879C47.2308 17.9572 42.3142 13 36.2796 13ZM36.2555 32.5877C31.5553 32.5877 27.7205 28.7281 27.7205 24.0241H25.2802C25.2802 26.1831 25.8933 28.2094 26.9752 29.9101C26.4223 30.0669 25.8573 30.1513 25.2802 30.1513C21.9264 30.1513 19.1735 27.4013 19.1735 24.0241C19.1735 20.659 21.9143 17.8969 25.2802 17.8969C26.6146 17.8969 27.8648 18.3191 28.9467 19.1272C30.5094 20.2972 31.387 22.0822 31.387 24.0121H33.8273C33.8273 21.455 32.7333 19.0789 30.7739 17.4507C32.3126 16.1721 34.236 15.4485 36.2555 15.4485C40.9558 15.4485 44.7905 19.3081 44.7905 24.0121C44.8026 28.7281 40.9798 32.5877 36.2555 32.5877Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNuvemshop);
export default __webpack_public_path__ + "static/media/nuvemshop.2824df298a730a3161f6792cf5bccd1a.svg";
export { ForwardRef as ReactComponent };